module.exports = __webpack_public_path__ + "img/nc.be825203.svg";